import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import Translation from "../../../../common/translation/translation.component"
import { TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import {
    OR_RRF_Select as Select
    , OR_RRF_TextArea as TextArea
    , ORFButton
    , ORFSearchSuggestions as SearchSuggestions
} from '../../../../common/forms/order-request-form.component';
import { createRequestActions } from "./../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../store/external/request-reducer/request-log.reducer";
import { wirelessReplaceSimActions } from "./../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-replace-sim.reducer";


class MobileReplaceSimForm extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.onReplaceSimFormLoad();
    }

    componentWillUnmount() {
        this.props.resetWirelessReplaceSimForm();
        this.props.resetRequestData();
    }

    submitRequest = async () => {
        const { submitRequest, modalMessage, fetchRequestLogItems } = this.props;

        var success = await submitRequest();
        if (success.Success) {
            fetchRequestLogItems(0);
        }
        modalMessage(success);
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {
        const {
            //form
            wirelessReplaceSimFormA
            //reducer action
            , setRequestorAddress
            , onSubscriptionSelect
            , fetchSubscriptionByValue
            , onCountrySelect
            , onAddressSelect
            ,isRequestOnBehalf
            , requestOnBehalfData
        } = this.props;
        const { subscriptionList, takeActionCircuitCode } = this.props.createRequest;
        const { subscription, simOptions, countryOptions, addressOptions, formSubmitted } = this.props.wirelessReplaceSimRequest;

        let showPreferredAddress = wirelessReplaceSimFormA.deliveryAddressId === "0";

        let disable = wirelessReplaceSimFormA.circuitId == 0
            || wirelessReplaceSimFormA.simTypeId == 0
            || wirelessReplaceSimFormA.circuitId == 0
            || wirelessReplaceSimFormA.deliveryAddressId == ''
            || (isRequestOnBehalf && !(requestOnBehalfData && requestOnBehalfData.EmployeeId > 0))
            || formSubmitted;

        if (showPreferredAddress) {
            disable = disable || wirelessReplaceSimFormA.otherLocationAddress == '';
        }

        return (
            <div>
                <Form method="post" role="form"
                    model="wirelessReplaceSimFormA"
                    onSubmit={this.submitRequest}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <SearchSuggestions
                                value={wirelessReplaceSimFormA.circuitCode}
                                label={`${this.toLocaleLanguage('subscription_number')} *`}
                                propDisplay={'CircuitCode'}
                                options={subscriptionList.length > 0 ? subscriptionList : ''}
                                onChangeAction={onSubscriptionSelect}
                                searchAction={fetchSubscriptionByValue}
                                defaultValue={takeActionCircuitCode}
                            />
                        </Col>
                        {wirelessReplaceSimFormA.circuitCode != '' &&
                            <div className="pb-15-pl-30">
                                {subscription.PlanName} <span>&#8226;</span> {subscription.SimName} <span>&#8226;</span> {subscription.DeviceName != null && subscription.DeviceName != '' ? subscription.DeviceName : <Translation translationKey="no_device_available" />}
                            </div>
                        }
                    </Row>
                    <div>
                        <span className='text-field-title'><Translation translationKey="order_request_details" /></span>
                    </div>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('new_sim_type')} *`}
                                value={wirelessReplaceSimFormA.simTypeId}
                                options={simOptions}
                                placeholder={this.toLocaleLanguage('select_sim_type')}
                                fieldProp='.simTypeId'
                                disabled={wirelessReplaceSimFormA.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('country')} *`}
                                value={wirelessReplaceSimFormA.countryCode}
                                options={countryOptions}
                                placeholder={this.toLocaleLanguage('select_a_country')}
                                fieldProp='.countryCode'
                                disabled={wirelessReplaceSimFormA.circuitId == 0}
                                onChangeAction={onCountrySelect}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <div className='use-request-container'>
                            <span onClick={setRequestorAddress} className="requestor-address-link">Use Requestor Address</span>
                        </div>
                        <Col xs={12} md={12} lg={12}>                            
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('delivery_address')} *`}
                                value={wirelessReplaceSimFormA.deliveryAddressId}
                                options={addressOptions}
                                placeholder={this.toLocaleLanguage('select_an_address')}
                                fieldProp='.deliveryAddressId'
                                disabled={wirelessReplaceSimFormA.circuitId == 0}
                                onChangeAction={onAddressSelect}
                            />
                        </Col>
                    </Row>
                    {
                        wirelessReplaceSimFormA.deliveryAddress != '' && 
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <div className="pb-15-pl-30">
                                    {wirelessReplaceSimFormA.deliveryAddress}
                                </div>
                            </Col>
                        </Row>
                    }
                    {showPreferredAddress &&
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={`${this.toLocaleLanguage('preferred_delivery_address')} *`}
                                fieldProp='.otherLocationAddress'
                                value={wirelessReplaceSimFormA.otherLocationAddress} />
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea 
                                label={this.toLocaleLanguage('additional_information')}
                                fieldProp='.additionalInformation'
                                value={wirelessReplaceSimFormA.additionalInformation}
                                disabled={wirelessReplaceSimFormA.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={this.onClickCancel}
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={this.toLocaleLanguage('submit_request_button')}
                                    variant={"primary"}
                                    type="submit"
                                    disabled={disable}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default connect(
    state => {
        const { wirelessReplaceSimRequest, createRequest, translation } = state;
        const { wirelessReplaceSimFormA } = state.form;
        return {
            wirelessReplaceSimRequest
            , wirelessReplaceSimFormA
            , createRequest
            , ...translation,
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelessReplaceSimActions
                , createRequestActions
                , requestLogActions),
            dispatch
        )
)(MobileReplaceSimForm);